export const NZ_FIELDS = {
  prohibited_entry: {
    answer: {
      type: 'yes-no-buttons'
    }
  }
}

export const NZ_APPLICATION_FIELDS = {
  purpose: {
    type: 'buttons',
    props: {
      label: 'Reason for Travel',
      options: [
        { label: 'Visit', value: 'visit' },
        { label: 'Transit', value: 'transit' }
      ]
    }
  },
  transit_acknowledgement: {
    type: 'gwa-checkbox',
    props: {
      label: 'I understand and confirm that I meet these transit conditions.'
    },
    validators: {
      validation: ['acknowledged']
    }
  },
  medical: {
    type: 'yes-no-buttons',
    validators: {
      validation: ['ineligible']
    }
  }
}
